import * as yup from 'yup';

export const schema = yup
  .object({
    perfil: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
    icms_st: yup.boolean(),
    icms_op: yup.boolean(),
    validar_somente_pela_ref: yup.boolean(),
    atualiza_forn_preferencial: yup.boolean(),
    flg_considera_ibs_cbs: yup.boolean(),
  })
  .required();
